// extracted by mini-css-extract-plugin
module.exports = {"summaryHeaderContainer":"styles__summaryHeaderContainer--2UsX3","graphsHeaderContainer":"styles__graphsHeaderContainer--2ZqoH","subheading":"styles__subheading--jOT3E"};